import { SectionHeading } from "@/components/common/SectionHeading";
import { PillLink } from "@/components/common/PillLink";
import { CourseCard } from "@/components/home/CourseCard";
import { COURSES } from "@/lib/site";

export const CoursesSection = () => (
  <section className="pt-8 pb-10 lg:pt-10 lg:pb-14" aria-labelledby="courses-title" data-testid="courses-section">
    <div className="container-x">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading id="courses-title" title="Four ways to get curious"
          intro="Every course is built around real questions. All four courses are taught through project-based learning (PBL), so learners investigate, make and explain instead of memorising." />
        <PillLink to="/courses" variant="outline" arrow data-testid="courses-view-all">Courses</PillLink>
      </div>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {COURSES.map((c, i) => <CourseCard key={c.slug} course={c} index={i} />)}
      </div>
    </div>
  </section>
);
